import React, { Component } from "react";

const Home = React.lazy(() => import("../pages/Home/home"));
const Provider = React.lazy(() => import("../pages/Provider/Provider"));


const components = {
    Home: {
        path: "/",
        name: "Home",
        element: <Home />,
    },
    Provider: {
        path: "/base/provider",
        name: "Provider",
        element: <Provider />,
    }
}

const routes = [ components.Home, components.Provider]

export { routes }